import React__default from 'react';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice } from '@grandvisionhq/utils';
import { SelectToggleButton } from '../../SelectToggleButton/SelectToggleButton.js';
import { PriceAside } from '../PriceAside/PriceAside.js';
import { getDiscountPerPack } from '../../../utils/cart-discounts.js';
import { TileLayout } from '../../../../components/TileLayout/TileLayout.js';

const QuantityDiscountItemLayout = ({ item , price , priceIsCentAmount , currency , selectedValue , onChange ,  })=>{
    const { locale , getFormattedLabel , getLabel  } = useIntl();
    const discountedPrice = price - getDiscountPerPack(price, item.amount, item.type, priceIsCentAmount);
    const formattedPrice = formatPrice({
        locale,
        value: discountedPrice,
        currency,
        isCentAmount: !!priceIsCentAmount
    });
    const title = getFormattedLabel('products.contactLenses.quantityDiscountSelect.title', {
        labelData: {
            minimumQuantity: item.minimumQuantity,
            price: formattedPrice
        }
    });
    const isSelected = selectedValue === item.minimumQuantity;
    return /*#__PURE__*/ React__default.createElement(SelectToggleButton, {
        isSelected: isSelected,
        onItemClick: ()=>onChange(!isSelected ? {
                quantity: item.minimumQuantity,
                originalUnitPrice: price,
                discountedUnitPrice: discountedPrice
            } : undefined)
        ,
        "data-t": `quantity-discount-select-${item.minimumQuantity}`,
        name: title
    }, /*#__PURE__*/ React__default.createElement(TileLayout, {
        title: title,
        subtitle: getLabel('products.contactLenses.quantityDiscountSelect.subTitle'),
        aside: /*#__PURE__*/ React__default.createElement(PriceAside, {
            item: item,
            currency: currency
        }),
        className: "quantity-discount-select__tile"
    }));
};

export { QuantityDiscountItemLayout };
//# sourceMappingURL=QuantityDiscountItemLayout.js.map
